import useRequest from "~/composables/use-request";
import { EVENT_STATUS, SEGMENT_TRACK_EVENTS } from "~/constants";
import useEventStore from "~/stores/event";
import {
  formatTag,
  formatTagsCreateOption,
  formatTagsUpdateOptions,
} from "./format";

const TagsAPI = {
  load(options: { id: string; global: boolean }): Promise<IModelTag[]> {
    const { request } = useRequest();
    const payload: IRequestTagsOptions = {
      global: options.global,
      page: 0,
      size: 50,
      targetId: options.id,
    };

    return request
      .post<IPaginatedResponse<IResponseTag>>("/api/tag/list", { body: payload })
      .then(response => response.content.entries.map(item => formatTag(item)));
  },
  async save(tag: IModelTag): Promise<IModelTag> {
    const segment = useSegment();
    const { request } = useRequest();
    const eventStore = useEventStore();

    const options: IRequestTagsCreateOptions = formatTagsCreateOption(tag);

    return request
      .post<IContentResponse<IResponseTag>>("/api/tag/saveV2", { body: options })
      .then((response) => {
        const createdTag = formatTag(response.content);

        const video_type = eventStore.data?.eventStatus === EVENT_STATUS.LIVE ? EVENT_STATUS.LIVE : "vod";
        segment.track(SEGMENT_TRACK_EVENTS.TAG_CREATED, {
          event_id: eventStore.data?.id || "",
          video_type,
          type: tag.type,
        });

        return createdTag;
      });
  },
  update(tag: IModelTag): Promise<IModelTag> {
    const { request } = useRequest();
    const payload: IRequestTagsUpdateOptions = formatTagsUpdateOptions(tag);
    return request
      .post<IContentResponse<IResponseTag>>("/api/tag/update", { body: payload })
      .then((response) => {
        return formatTag(response.content);
      });
  },
  delete(tagId: string): Promise<void> {
    return TagsAPI.bulkDelete([tagId]);
  },
  bulkDelete(tagIds: string[]): Promise<void> {
    const { request } = useRequest();
    const params = { ids: tagIds };
    return request
      .post<IContentResponse<any>>("/api/tag/remove_list", { body: params })
      .then(() => {
        // Return void - cache invalidation will handle reactivity
      });
  },
};

export default TagsAPI;
